import React from "react";
import CustomText from "../components/CustomText";
import FeatureCard from "../components/cards/FeatureCard";
import IndustryCard from "../components/cards/IndustryCard";
import TestimonialCard from "../components/cards/TestimonialCard";
import InfoCard from "../components/cards/InfoCard";
import PricingCard from "../components/cards/PricingCard";
import HeroSection from "../components/HeroSection";

const ComponentsPage = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1 style={{ textAlign: "center", marginBottom: "40px" }}>
        Components Showcase
      </h1>

      {/* HeroSection Component */}
      <section style={{ marginBottom: "40px" }}>
        <HeroSection
          backgroundImage="https://via.placeholder.com/1500"
          title="Hero Section Title"
          subtitle="This is a subtitle for the hero section."
        >
          <button style={{ padding: "10px 20px", fontSize: "16px" }}>
            Learn More
          </button>
        </HeroSection>
      </section>

      {/* CustomText Component */}
      <section style={{ marginBottom: "40px" }}>
        <CustomText
          style={{ fontSize: "24px", fontWeight: "bold", color: "#333" }}
        >
          This is a CustomText component with bold styling.
        </CustomText>
        <CustomText style={{ fontSize: "18px", color: "#555" }}>
          This is another CustomText component with smaller font size.
        </CustomText>
      </section>

      {/* FeatureCard Component */}
      <section style={{ marginBottom: "40px" }}>
        <h2>Feature Cards</h2>
        <div style={{ display: "flex", gap: "20px" }}>
          <FeatureCard
            title="Feature 1"
            description="This is a description of the first feature."
            icon={<span>🔥</span>}
          />
          <FeatureCard
            title="Feature 2"
            description="This is a description of the second feature."
            icon={<span>🚀</span>}
          />
        </div>
      </section>

      {/* IndustryCard Component */}
      <section style={{ marginBottom: "40px" }}>
        <h2>Industry Cards</h2>
        <div style={{ display: "flex", gap: "20px" }}>
          <IndustryCard
            title="Industry 1"
            description="This is a description of the first industry."
            imageUrl="https://via.placeholder.com/150"
          />
          <IndustryCard
            title="Industry 2"
            description="This is a description of the second industry."
            imageUrl="https://via.placeholder.com/150"
          />
        </div>
      </section>

      {/* TestimonialCard Component */}
      <section style={{ marginBottom: "40px" }}>
        <h2>Testimonial Cards</h2>
        <div style={{ display: "flex", gap: "20px" }}>
          <TestimonialCard
            name="John Doe"
            testimonial="This is a testimonial from John Doe."
            avatarUrl="https://via.placeholder.com/100"
          />
          <TestimonialCard
            name="Jane Smith"
            testimonial="This is a testimonial from Jane Smith."
            avatarUrl="https://via.placeholder.com/100"
          />
        </div>
      </section>

      {/* InfoCard Component */}
      <section style={{ marginBottom: "40px" }}>
        <h2>Info Cards</h2>
        <div style={{ display: "flex", gap: "20px" }}>
          <InfoCard
            title="Info 1"
            description="This is some informational text for the first card."
            linkText="Learn More"
            onLinkClick={() => alert("Info 1 clicked!")}
          />
          <InfoCard
            title="Info 2"
            description="This is some informational text for the second card."
            linkText="Learn More"
            onLinkClick={() => alert("Info 2 clicked!")}
          />
        </div>
      </section>

      {/* PricingCard Component */}
      <section style={{ marginBottom: "40px" }}>
        <h2>Pricing Cards</h2>
        <div style={{ display: "flex", gap: "20px" }}>
          <PricingCard
            title="Basic"
            price="$12"
            description="For Freelancers, Small Teams, or Startups"
            features={[
              "Free Administrator Users",
              "Mobile Apps",
              "Time Tracking",
            ]}
            buttonText="Try Free"
            onButtonClick={() => alert("Basic Plan Selected")}
          />
          <PricingCard
            title="Pro"
            price="$34"
            description="For growing teams tracking time, tasks, and performance"
            features={[
              "Basic Geofencing",
              "QR Code Scanning",
              "GPS validation",
            ]}
            buttonText="Try Free"
            onButtonClick={() => alert("Pro Plan Selected")}
          />
          <PricingCard
            title="Enterprise"
            price="$150"
            description="For large organizations or enterprises"
            features={[
              "Unlimited users & tracking",
              "Full API access",
              "Custom roles & integrations",
            ]}
            buttonText="Try Free"
            onButtonClick={() => alert("Enterprise Plan Selected")}
            isHighlighted
          />
        </div>
      </section>
    </div>
  );
};

export default ComponentsPage;
